import React from "react";

const LINK_URL = "https://www.cafe24.com/commerce/service/cafe24pro.html?utm_source=coop&utm_medium=page&utm_campaign=saveoffice";

/**
 * 세이브오피스 X CAFE24 프로모션 상세 페이지.
 * Hero / 고민 / 솔루션 / 후기 / CTA + 사업자 정보 5개 섹션으로 구성.
 */
const Promotion2 = () => {
  /** CTA "무료 혜택 받기" 클릭 시 카페24 PRO 서비스 페이지를 새창으로 오픈. */
  const handleCTAClick = () => {
    window.open(
      LINK_URL,
      "_blank"
    );
  };

  return (
    <div className="promotion-cafe24-container flex w-full justify-center bg-white text-left text-[#1C1C1C]">
      <section className="flex w-full flex-col">
        {/* Hero */}
        <div className="relative w-full bg-[#0074FF] overflow-hidden">
          <img
            src="/assets/promotion/3/hero-bg.png"
            alt=""
            className="absolute inset-0 w-full h-full object-cover opacity-80 pointer-events-none"
            loading="eager"
          />
          <div className="relative max-w-[1080px] mx-auto px-[60px] 800r:px-[20px] pt-[200px] pb-[120px] 800r:pt-[140px] 800r:pb-[60px] text-center">
            <h1 className="mt-[40px] 800r:mt-[20px] text-white text-[56px] 1200r:text-[40px] 800r:text-[24px] leading-[1.35] font-extrabold tracking-[-1.5px] [text-shadow:0_10.711px_10.711px_rgba(0,0,0,0.25)]">
              운영 인력 없이도,
              <br />
              온라인 몰 구축·운영 끝 !
            </h1>
            <p className="mt-[24px] 800r:mt-[14px] text-white text-[36px] 1200r:text-[26px] 800r:text-[16px] leading-[1.5] font-bold [text-shadow:0_10.711px_10.711px_rgba(0,0,0,0.25)]">
              <span>“ 지금 신청하면 </span>
              <span className="text-[#ebff00]">6개월 무료 혜택</span>
              <span> ”</span>
            </p>
            <p className="mt-[36px] 800r:mt-[20px] text-[#35FDD5] text-[26px] 1200r:text-[20px] 800r:text-[14px] font-bold [text-shadow:0_10.711px_10.711px_rgba(0,0,0,0.25)]">
              세이브오피스 신청 고객 특별 혜택
            </p>
          </div>
        </div>

        {/* 고민 섹션 */}
        <div className="w-full bg-white py-[140px] 800r:py-[60px] px-[20px]">
          <div className="max-w-[1080px] mx-auto">
            <h2 className="text-[44px] 1200r:text-[32px] 800r:text-[22px] font-extrabold text-[#1C1C1C] leading-[1.4] tracking-[-1px] text-left">
              혹시, 이런 고민하고 있진 않으신가요? 😞
            </h2>
            <div className="mt-[60px] 800r:mt-[36px] grid grid-cols-3 1200r:grid-cols-1 gap-[24px] 1200r:gap-[16px]">
              {WORRY_CARDS.map((card) => (
                <div
                  key={card.label}
                  className="rounded-[36px] 800r:rounded-[24px] overflow-hidden border border-[#F2F2F2] flex flex-col"
                >
                  <div className="bg-[#F5F8FF] flex items-center justify-center gap-[16px] px-[24px] py-[36px] 800r:py-[20px]">
                    <img
                      src={card.icon}
                      alt=""
                      className="w-[80px] h-[80px] 800r:w-[60px] 800r:h-[60px]"
                    />
                    <div className="text-[32px] 800r:text-[22px] font-extrabold text-[#1C1C1C]">
                      {card.label}
                    </div>
                  </div>
                  <div className="flex flex-col flex-1">
                    <p className="text-[20px] 800r:text-[15px] font-semibold text-[#1C1C1C] leading-[1.4] px-[28px] py-[28px] 800r:py-[20px] border-b border-[#F2F2F2]">
                      {card.line1}
                    </p>
                    <p className="text-[20px] 800r:text-[15px] font-semibold text-[#1C1C1C] leading-[1.4] px-[28px] py-[28px] 800r:py-[20px]">
                      {card.line2}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* 솔루션 섹션 */}
        <div className="w-full bg-white py-[120px] 800r:py-[60px] px-[20px]">
          <div className="max-w-[1080px] mx-auto">
            <h2 className="text-[44px] 1200r:text-[32px] 800r:text-[22px] font-extrabold text-[#1C1C1C] leading-[1.4] tracking-[-1px]">
              카페24 PRO 하나면 가능합니다. 😀
            </h2>
            <p className="mt-[28px] 800r:mt-[16px] text-[20px] 1200r:text-[18px] 800r:text-[14px] text-[#616161] leading-[1.6]">
              카페24 PRO는 고객의 쇼핑몰을{" "}
              <span className="font-bold text-[#1C1C1C]">
                '잘 팔리는 환경'
              </span>
              으로 구성하고 주도적으로 운영해드리는 서비스예요.
              <br />
              여러분은{" "}
              <span className="font-bold text-[#1C1C1C]">상품 제작 및 배송</span>
              만 신경 쓸 수 있도록 온라인 운영을 카페24의 전문가들이 대신해
              드려요!
            </p>
            <div className="mt-[60px] 800r:mt-[36px] flex flex-col gap-[28px] 800r:gap-[20px]">
              {SOLUTION_STEPS.map((step) => (
                <div
                  key={step.title}
                  className="flex items-center gap-[36px] 800r:gap-[16px]"
                >
                  <img
                    src={step.icon}
                    alt=""
                    className="w-[120px] h-[120px] 800r:w-[80px] 800r:h-[80px] flex-shrink-0 rounded-full bg-[#FAFAFA]"
                  />
                  <div className="flex flex-col gap-[8px]">
                    <h3 className="text-[28px] 1200r:text-[22px] 800r:text-[16px] font-extrabold text-[#1C1C1C] leading-[1.4]">
                      {step.title}
                    </h3>
                    <p className="text-[18px] 1200r:text-[16px] 800r:text-[13px] text-[#616161] leading-[1.5]">
                      {step.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* 후기 섹션 */}
        <div className="w-full bg-white py-[120px] 800r:py-[60px] px-[20px]">
          <div className="max-w-[1080px] mx-auto">
            <h2 className="text-[44px] 1200r:text-[32px] 800r:text-[22px] font-extrabold text-[#282828] leading-[1.4] tracking-[-1px]">
              이용해본 고객의 찐 후기!
            </h2>
            <div className="mt-[60px] 800r:mt-[36px] flex flex-col gap-[60px] 800r:gap-[36px]">
              {REVIEWS.map((review, idx) => (
                <div
                  key={review.brand}
                  className={`flex 1200r:flex-col items-center gap-[48px] 800r:gap-[20px] ${
                    idx % 2 === 1 ? "flex-row-reverse" : ""
                  }`}
                >
                  <img
                    src={review.img}
                    alt={review.brand}
                    className="w-[480px] h-[286px] 1200r:w-full 1200r:max-w-[600px] 1200r:h-auto 1200r:aspect-[16/10] object-cover rounded-[12px]"
                    loading="lazy"
                  />
                  <div className="flex-1 flex flex-col gap-[24px] 800r:gap-[16px]">
                    <h3 className="text-[26px] 1200r:text-[22px] 800r:text-[16px] font-extrabold text-[#1C1C1C] leading-[1.4]">
                      [{review.brand}]
                      <br />
                      {review.title}
                    </h3>
                    <p className="text-[18px] 1200r:text-[16px] 800r:text-[13px] text-[#555] leading-[1.6]">
                      {review.body}
                    </p>
                    <a
                      href={LINK_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-[6px] text-[#777] text-[18px] 800r:text-[14px] font-medium hover:text-[#1C1C1C] transition-colors w-fit"
                    >
                      이야기 이어보기
                      <img
                        src="/assets/promotion/3/arrow.svg"
                        alt=""
                        className="w-[10px] h-[16px] 800r:w-[8px] 800r:h-[12px]"
                      />
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* CTA 배너 + 버튼 */}
        <div className="w-full bg-white pt-[80px] pb-[60px] 800r:py-[40px] px-[20px]">
          <div className="flex flex-col items-center max-w-[1080px] mx-auto">
            <div className="bg-black mx-auto px-[60px] py-[20px] 800r:px-[36px] 800r:py-[12px]">
              <p className="text-white text-[40px] 1200r:text-[28px] 800r:text-[18px] font-extrabold leading-[1.4] tracking-[-1px]">
                <span>지금 신청하면 </span>
                <span className="text-[#67FF32]">6개월 무료 혜택 제공 !</span>
              </p>
              <p className="mt-[12px] 800r:mt-[8px] text-white text-[40px] 1200r:text-[28px] 800r:text-[18px] font-extrabold leading-[1.4] tracking-[-1px]">
                <span>쇼핑몰 운영, </span>
                <span className="text-[#67FF32]">카페24 PRO</span>
                <span>가 도와드립니다</span>
              </p>
            </div>
            <button
              type="button"
              onClick={handleCTAClick}
              className="mx-auto mt-[40px] 800r:mt-[24px] block bg-[#084FFF] text-white px-[60px] py-[20px] 800r:px-[40px] 800r:py-[14px] rounded-full text-[24px] 800r:text-[16px] font-bold hover:bg-[#063fcc] transition-colors"
            >
              무료 혜택 받기
            </button>
          </div>
        </div>

        {/* 카페24 사업자 정보 */}
        <div className="w-full flex flex-col items-center bg-white pb-[40px] px-[20px] gap-[12px]">
          <div className="max-w-[1080px] mx-auto text-[#1D1B1B] text-[24px] 800r:text-[18px] leading-[1.6] text-center">
            카페24(주) | 02-6276-1871 | jhyang@cafe24corp.com
          </div>
          <div className="max-w-[1080px] mx-auto text-[#1D1B1B] text-[24px] 800r:text-[18px] leading-[1.6] text-center">
            서울특별시 동작구 보라매로5길 15(신대방동, 전문건설회관)
          </div>
        </div>
      </section>
    </div>
  );
};

/** 고민 섹션 카드 데이터 (몰 구축 / 인력부족 / 활성화) */
const WORRY_CARDS = [
  {
    label: "몰 구축",
    icon: "/assets/promotion/3/worry-1.png",
    line1: "쇼핑몰을 시작하려는데 무엇을 해야할지 모르겠어요.",
    line2: "디자인, 상품 진열, 결제·배송 설정까지 혼자 만들기엔 너무 막막해요.",
  },
  {
    label: "인력부족",
    icon: "/assets/promotion/3/worry-2.png",
    line1: "사내 전문가가 없어서 FAQ, CX 관리가 전혀 안돼요.",
    line2: "매일 쇼핑몰 세부사항까지 모니터링 하기가 쉽지 않아요.",
  },
  {
    label: "활성화",
    icon: "/assets/promotion/3/worry-3.png",
    line1: "매출 비중을 마켓에서 자사몰로 확장하고 싶어요.",
    line2: "마켓 상품들이 한곳에서 알아서 관리되게 하고 싶어요.",
  },
];

/** 솔루션 섹션 4단계 데이터 */
const SOLUTION_STEPS = [
  {
    icon: "/assets/promotion/3/step-1.png",
    title: "온라인 브랜드몰 운영 및 관리",
    desc: "카페24 쇼핑몰의 운영과 관리 업무를 서포트 해드려요.",
  },
  {
    icon: "/assets/promotion/3/step-2.png",
    title: "멀티채널 판매 기반 구축",
    desc: "스마트스토어, 쿠팡 등 마켓을 한번에 연동하고, 판매채널을 확장해 드려요.",
  },
  {
    icon: "/assets/promotion/3/step-3.png",
    title: "고객 접근성 증진",
    desc: "알고리즘에 맞춘 키워드 최적화로 검색순위를 높여 신규고객 유입을 증진시켜드려요.",
  },
  {
    icon: "/assets/promotion/3/step-4.png",
    title: "신규/기존 고객 대상 마케팅",
    desc: "재방문 유도 메시지, 휴면회원 관리, 이탈 방지, 프로모션 디자인 등 알아서 진행해드려요.",
  },
];

/** 후기 섹션 3개 브랜드 데이터 */
const REVIEWS = [
  {
    brand: "풍년보감",
    title: "검색만 해도 우리 상품이 보여요! 👀",
    body: "“운영 효율이 개선되니 CRM 고도화를 위해 고객 리뷰 분석 및 VOC 분석이 가능했죠. 이를 기반으로 업무 프로세스를 새롭게 세팅하고 더 나은 가치를 제공할 수 있게 되었어요.”",
    img: "/assets/promotion/3/review-pungnyeon.png",
  },
  {
    brand: "완도바다식품",
    title: "우리도 했다! 완도에서 전국까지 🗺️",
    body: "“저희가 절실히 필요로 했던 SEO, 리마인드 등을 20년 이상의 업력을 가진 대표 쇼핑몰 구축 솔루션에서 운영대행해준다니, 망설일 이유가 없었어요.”",
    img: "/assets/promotion/3/review-wando.png",
  },
  {
    brand: "슈퍼프레소",
    title: "우린 차(茶)만 만들어요, 운영은 PRO가",
    body: "“인력 부족으로 몰 운영이 힘들었는데, 상품 등록과 주문 수집 문제가 깔끔하게 해결됐어요. 카페24 PRO에서 마켓플러스를 활용해서 네이버스마트스토어, 쿠팡 등 입점몰에도 자동으로 등록해주니까요.”",
    img: "/assets/promotion/3/review-superpresso.png",
  },
];

export default Promotion2;
